import {create} from 'zustand';
import {AccordionExpandedEnum} from '../../types';
import {UseAccordionExpandedStoreProps} from './types';

export const useAccordionExpandedStore = create<UseAccordionExpandedStoreProps>(set => ({
	accordion: AccordionExpandedEnum.PROVIDER_DATA,
	setAccordion: accordion => set({accordion}),
	resetAccordion: () => set({accordion: AccordionExpandedEnum.PROVIDER_DATA}),
}));
